import { EditTicketModal } from "./EditTicketModal";

export default EditTicketModal;
